// Klubben og kontaktpersonen øverst på en klubbestilling fra klubbinfo (ordre eller trykk), i
// stedet for kunden (vinnsel, 03.11). Kontakten slås opp i klubbinfo av backend
// (`kontaktKlubb`, src/lib/klubbKontakt.js), og lenken går til klubbsiden.
import React from 'react';
import { Link } from 'react-router-dom';
import Ikon from '../ny-kundesamhandling/Ikon';

const ROLLE = { trener: 'Trener', innkjopsansvarlig: 'Innkjøpsansvarlig', kontakt: 'Kontakt' };

// Mottakeren i kundens form ({ firstName, phoneNumber, email }), til SMS, etikett og prisoversikt.
export function kontaktSomMottaker(k) {
  if (!k || k.fjernet) return null;
  return { firstName: k.navn, lastName: '', phoneNumber: k.telefon || '', email: k.epost || '' };
}

// Tydelig merke øverst på en klubbordre, et klubbtrykk eller et pristilbud til en klubb.
export function KlubbMerke({ klubbNavn, tekst = 'Klubbordre' }) {
  return (
    <span className="inline-flex max-w-full items-center gap-1.5 rounded-full bg-violet-700 px-3 py-1 font-bold text-white">
      <Ikon navn="folk" className="w-5 h-5 shrink-0" />
      <span className="min-w-0 [overflow-wrap:anywhere]">{tekst}{klubbNavn ? `: ${klubbNavn}` : ''}</span>
    </span>
  );
}

export default function KlubbKontaktBanner({ kontakt, linje }) {
  return (
    <Link
      to={`/klubber/${kontakt.klubbId}`}
      className="group flex flex-wrap items-center gap-2 rounded-2xl border border-violet-200 bg-violet-50 p-3 transition hover:bg-violet-100 focus:outline-none focus-visible:ring-4 focus-visible:ring-indigo-600/50"
    >
      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-violet-700 text-white">
        <Ikon navn="folk" className="w-7 h-7" />
      </span>
      <span className="min-w-0 flex-1 basis-48">
        <span className="block text-base font-bold text-slate-900 [overflow-wrap:anywhere]">{kontakt.klubbNavn || 'Klubben'}</span>
        {kontakt.fjernet ? (
          <span className="block text-slate-700">Kontaktpersonen er fjernet fra klubbinfo.</span>
        ) : (
          <span className="block text-slate-700 [overflow-wrap:anywhere]">
            {kontakt.navn} ({ROLLE[kontakt.rolle] || kontakt.rolle}{kontakt.tittel ? `, ${kontakt.tittel}` : ''}) ·{' '}
            <span className="font-mono">{kontakt.telefon || 'Uten mobil'}</span>
            {kontakt.epost && <> · {kontakt.epost}</>}
          </span>
        )}
        {linje && <span className="block text-sm text-slate-600">{linje}</span>}
      </span>
      <span className="flex items-center gap-1 font-semibold text-indigo-700">
        Klubbsiden <Ikon navn="pil" className="w-5 h-5 transition group-hover:translate-x-0.5" />
      </span>
    </Link>
  );
}
